import React from 'react';
import {Card, Table} from 'semantic-ui-react';
import {useTableAudit} from './useTableAudit';
import './styles.scss';
import TablePaginator from '../../commons/tablePaginator';
import {Filter, FloatingInventoryAuditFilter} from './TableFilters';
import {EmptyDataCard} from './emptyDataCard';

const TableAudit = ({
  columnsTable = [],
  dataTable = [],
  updateTable,
  resetAllFilters,
  showFilters,
  setResetAllFilters,
  setShowFilters,
}) => {
  const {
    'actions': {
      'useTableValues': {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        page,
        canPreviousPage,
        canNextPage,
        pageOptions,
        gotoPage,
        nextPage,
        previousPage,
        setPageSize,
        'state': {pageIndex, pageSize},
      },
    },
  } = useTableAudit({
    columnsTable,
    dataTable,
    updateTable,
    FloatingInventoryAuditFilter,
    resetAllFilters,
    setResetAllFilters,
  });
  return (
    <>
      {!dataTable.length ? (
        <EmptyDataCard />
      ) : (
        <Card fluid>
          <div>
            <div className='container-floating-audit'>
              <Table
                unstackable
                className='interactive'
                compact
                striped
                {...getTableProps()}>
                <Table.Body {...getTableBodyProps()}>
                  {!page.length && (
                    <Table.Row>
                      <Table.Cell colSpan={100} textAlign='center'>
                        No hay datos disponibles
                      </Table.Cell>
                    </Table.Row>
                  )}
                  {page.length > 0 &&
                    page.map((row, i) => {
                      prepareRow(row);
                      return (
                        <Table.Row
                          key={i}
                          className={'row-custom row-floating-inventory'}
                        >
                          {row.cells.map((cell, index) => {
                            return (
                              <Table.Cell
                                key={index}
                                textAlign='center'
                                className={`${cell.column.className} cell-custom-floating`}
                                collapsing>
                                {cell.render('Cell')}
                              </Table.Cell>
                            );
                          })}
                        </Table.Row>
                      );
                    })}
                </Table.Body>
                <Table.Header className='sticky'>
                  {headerGroups.map((headerGroup) => (
                    <Table.Row>
                      {headerGroup.headers.map((column, index) => {
                        return (
                          <Table.HeaderCell
                            key={`title-${index}`}
                            textAlign='center'
                            className='th-semanctic-custom floating-reduce-spacing'
                            {...column.getHeaderProps()}>
                            {column.render('Header')}
                          </Table.HeaderCell>
                        );
                      })}
                    </Table.Row>
                  ))}
                  {showFilters && headerGroups.map((headerGroup) => (
                    <Table.Row key='filters' id='filters'>
                      {headerGroup.headers.map((column, index) => (
                        <Table.HeaderCell
                          key={`filter-${index}`}
                          textAlign='center'>
                          <Filter column={column} />
                        </Table.HeaderCell>
                      ))}
                    </Table.Row>
                  ))}
                </Table.Header>
              </Table>
            </div>
            <div>
              <TablePaginator
                page={page}
                canPreviousPage={canPreviousPage}
                pageIndex={pageIndex}
                pageOptions={pageOptions}
                pageSize={pageSize}
                canNextPage={canNextPage}
                nextPage={nextPage}
                gotoPage={gotoPage}
                previousPage={previousPage}
                setPageSize={setPageSize}
              />
            </div>
          </div>
        </Card>
      )}
    </>
  );
};

export default TableAudit;
